import { CoralogixRum } from '@coralogix/browser'
import { AppContainer } from '@myneva/ui'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { AuthProvider } from 'react-oidc-context'
import { App } from './App'
import { oidcParams } from './oidcConfig'

declare global {
  interface Window {
    CoralogixRum: typeof CoralogixRum
  }
}

const container = document.getElementById('root')
const root = createRoot(container!)

if (window.CoralogixRum) {
  window.CoralogixRum.init({
    application: 'aws-myneva-platform',
    environment: process.env.REACT_APP_ENVIRONMENT!,
    public_key: 'cxtp_lM5RrfkUzZZM3ftyrDmqJ5pYUBREDn',
    coralogixDomain: 'EU1',
    version: process.env.REACT_APP_VERSION!,
    instrumentations: {
      xhr: true,
      fetch: true,
      web_vitals: true,
      interactions: true,
      custom: true,
      errors: true,
      long_tasks: true,
      resources: true,
    },
    sessionRecordingConfig: {
      enable: true,
      autoStartSessionRecording: true,
      recordConsoleEvents: true,
      sessionRecordingSampleRate: 100,
    },
    traceParentInHeader: {
      enabled: true,
      options: {
        propagateAwsXrayTraceHeader: true,
      },
    },
  })
}

const isLocalhost = () => typeof window.location != 'undefined' && window.location.href.indexOf('localhost') > -1
let oidcConfig
if (isLocalhost()) {
  oidcConfig = oidcParams.localhost
} else if (process.env.REACT_APP_ENVIRONMENT === 'development') {
  oidcConfig = oidcParams.development
} else if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
  oidcConfig = oidcParams.staging
} else if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  oidcConfig = oidcParams.production
}

root.render(
  <React.StrictMode>
    <AppContainer>
      <AuthProvider {...oidcConfig}>
        <App />
      </AuthProvider>
    </AppContainer>
  </React.StrictMode>,
)
